export default {
  Url: 'https://api.playparchi.com/api/v1/',
  Image: 'https://playparchi.com/upload',
  base: 'https://playparchi.com',
};
